import React, { useEffect, useRef, useState } from 'react';
import parse from 'html-react-parser';
import './article.scss';
import { viewArticle, fetchArticle } from '../chatservice/zendeskApis';
import { postMessageToClient } from '../chatservice/communicationService';
import { config } from '../../config/config';

type ArticleDetailProps = {
    sessionId: any,
    userId: any,
    data: any
}


const ArticleDetail = ({sessionId, userId, data}: ArticleDetailProps) => {
    const articleStartRef: any = useRef(null);
    const [articleTitle, setArticleTitle] = useState("");
    const [articleBody, setArticleBody] = useState("");
    const [articleLink, setArticleLink] = useState("");
    const [isArticleFound, setIsArticleFound] = useState<any>(null);

    const clickHandler = () => {
        postMessageToClient({ name: "chatbotOpenArticle", articleName: data.text});
    }

    const scrollToStart = () => {
        articleStartRef?.current?.scrollIntoView({ behavior: "smooth" });
    }; 

    useEffect(() => {
        viewArticle(sessionId, userId, data.intentGroupId, data.queryId, data.articleId, true);
        scrollToStart();

        // fetch article data
        if (isArticleFound === null) {
            fetchArticle(data.articleId).then
                (response => {
                    if (!response.error) {
                        setArticleTitle(response.article.name);
                        setArticleBody(response.article.body);

                        const articlePageName = response.article.html_url && response.article.html_url.split('.zendesk.com/hc/en-us/articles/')[1];
                        setArticleLink(`${config.DAN_HELP_CENTRE_URL}/articles/${articlePageName}`);
                        setIsArticleFound(true);
                    } else {
                        setIsArticleFound(false);
                    }
                })
        }
    }, []);

    return (
        <div>
            {
                isArticleFound === true &&
                <div className="article__container article__container--stretch">
                    <div className="article__content-container"> 
                        <div ref={articleStartRef} />               
                        <div className="article__title">{parse(articleTitle)}</div>
                        <div className="article__content">{parse(articleBody)}</div>
                    </div>
                    <a href={ articleLink } target="_blank" rel="noopener noreferrer">
                        <img src="/images/open-article-icon.svg" onClick={clickHandler} alt="view article in a new tab" />
                    </a>
                </div>
            }

            { isArticleFound === null && <span>Loading ...</span> }
            { isArticleFound === false && <span>There was an issue loading the article you selected.  Please come back again at another time.</span> }
        </div>
        )
}

export default ArticleDetail
